<template>
  <div id="catalogSearchProducts" class="searchProducts">
    <div v-if="!topPage" class="searchProducts__scrollTop" @click.prevent="scrollToTop">
      <v-scroll-top-icon />
    </div>
    <transition-group class="searchProducts__list" tag="div" name="fade" mode="out-in">
      <v-search-product
        v-for="searchProduct in searchProducts"
        :key="searchProduct.productId"
        :search-product="searchProduct"
      />
    </transition-group>
  </div>
</template>



<script>
import VSearchProduct from './SearchProduct';
import VScrollTopIcon from 'icons/ArrowUpBoldBox';
import router from '@/router';

export default {
  name: 'VSearchProducts',
  components: {
    VSearchProduct,
    VScrollTopIcon
  },
  props: {
    searchProducts: {
      type: Array,
      default: () => []
    },
    assortmentFlow: {
      type: Boolean,
      default: false
    },
    searchProductsTerm: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    if (props.searchProducts && props.searchProducts.length > 0) {
      let products = []
      props.searchProducts.forEach(product => {
        products.push({
          item_id: product.baseProductId,
          item_name: product.title,
          item_brand: product.manufName,
          quantity: 1
        });
      });
      window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          item_list_name: router.currentRoute.value.path,
          search_term: props.searchProductsTerm,
          items: products
        }
      });
    }
  },
  data() {
    return {
      bottom: false,
      topPage: false
    };
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.$emit('loadMore');
      }
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible();
      this.topPage = this.topVisible();
    });
  },
  methods: {
    topVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      return scrollY === 0;
    },
    bottomVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = Math.ceil(visible + scrollY) >= Math.ceil(pageHeight);
      return bottomOfPage;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.searchProducts {
  &__scrollTop {
    bottom: 0;
    right: 0;
    position: fixed;
    cursor: pointer;
    .material-design-icon {
      fill: $aqua;
      :deep(svg) {
        width: 50px;
        height: 50px;
      }
    }
  }
  &__list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  &__Title {
    font-size: 30px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $teal-darkest;
    margin: 0px 0px 15px 0px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.searchProduct {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: $white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 8px;
  box-sizing: border-box;
  height: 100%;

  &__link {
    text-decoration: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  &__img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    margin-bottom: 16px;

    img {
      max-height: 100px;
      max-width: 100px;
      object-fit: contain;
    }
  }

  &__text {
    text-align: center;
    margin-bottom: 16px;
    flex: 1;

    &__name {
      color: $gray-darkest;
      font-weight: bold;
      font-size: 1.1em;
      margin: 0;
      margin-bottom: 8px;
    }

    &__manufacturer {
      font-size: 0.9em;
      font-weight: normal;
      line-height: normal;
      color: $gray-dark;
      margin: 0;

      span {
        display: block;
        margin-top: 4px;
      }
    }
  }

  &__noordertext {
    color: $gray-darkest;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
